<template>
  <div>
    <Select v-if="!group && !multiply" v-model="selectedValue" :disabled="disabled" @on-open-change="getData"
            :filterable="filterable" :placeholder="placeholder" transfer clearable>
      <Option
          v-for="item in entityData"
          :value="item[fieldConfig.idFieldChild]"
          :key="item[fieldConfig.idFieldChild]"
          :label="item[fieldConfig.nameFieldChild]"
          @click.native="setEntityName(item)">
        {{ getTagName(item) }}
      </Option>
    </Select>

    <Select v-else-if="group && !multiply" v-model="selectedValue" :disabled="disabled" @on-open-change="getData"
            :filterable="filterable" :placeholder="placeholder" transfer clearable>
      <OptionGroup v-for="(item,index) in entityData" :label="item.groupLabel" :key="index">
        <Option
            v-for="item1 in item.groupData"
            :value="item1[fieldConfig.idFieldChild]"
            :key="item1[fieldConfig.idFieldChild]"
            :label="item1[fieldConfig.nameFieldChild]"
            @click.native="setEntityName(item1)">
          {{ getTagName(item1) }}
        </Option>
      </OptionGroup>
    </Select>

    <Select v-else-if="group && multiply" v-model="selectedValues" multiple :disabled="disabled"
            @on-open-change="getData"
            :filterable="filterable" :placeholder="placeholder" transfer @on-change="getSelectValues">
      <OptionGroup v-for="(item,index) in entityData" :label="item.groupLabel" :key="index">
        <Option
            v-for="item1 in item.groupData"
            :disabled="(item1.id===curId)"
            :value="item1[fieldConfig.idFieldChild]"
            :key="item1[fieldConfig.idFieldChild]"
            :label="item1[fieldConfig.nameFieldChild]">
          {{ getTagName(item1) }}
        </Option>
      </OptionGroup>
    </Select>

    <Select v-else v-model="selectedValues" multiple :disabled="disabled" @on-open-change="getData"
            :filterable="filterable" :placeholder="placeholder" transfer @on-change="getSelectValues">
      <Option
          v-for="item in entityData"
          :disabled="(item.id===curId)"
          :value="item[fieldConfig.idFieldChild]"
          :key="item[fieldConfig.idFieldChild]"
          :label="item[fieldConfig.nameFieldChild]">
        {{ getTagName(item) }}
      </Option>
      <Option>
        <slot name="append"></slot>
      </Option>
    </Select>

  </div>
</template>

<script>
export default {
  name: "entitySelect",
  model: {
    event: "on-change",
    prop: "parentValue"
  },
  data() {
    return {
      entityData: [], //后台查询数据
      otherFieldName: [], //其他字段
      selectedValue: "", //单选选中值
      selectedValues: [], //多选选中值
      selectedLabels: [], //多选选中label
      selectOtherNames: [],
      otherFields: [], //主表所有需赋值的其他字段
      otherFieldsChild: [], //子表所有需赋值的其他字段
      otherFieldData: {},
      others: [],
      watchNum: 0,
      curId: 0,
      pastSelectedVals: []
    }
  },
  props: {
    parentValue: {
      type: String || Number || Object,
      default: () => {
      }
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    multiply: {
      type: Boolean,
      default: false
    },
    group: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    isCheck: {
      type: Boolean,
      default: false
    },
    queryUrl: String, //后台查询表单的路径
    queryParams: {}, //后台查询条件
    isQuery: { //list页面查询需要增加一个全选
      type: Boolean,
      default: false
    },
    field: String, //主表name字段
    fieldConfig: {
      type: Object,
      default: () => {
        return {
          idField: "", //主表需赋值id
          nameField: "", //主表需赋值name
          idFieldChild: "", //子表id字段
          nameFieldChild: "", //子表name字段
          otherField: "", //主表其他需要赋值的字段,例如：'devProductType,user（主表）@sysUserName（参照表）'
          showName: "" //显示字段
        };
      }
    }
  },
  async created() {
    if (!this.fieldConfig.idField) {
      const index = this.field.indexOf("Name");
      this.fieldConfig.idField = this.field.substr(0, index) + "Id";
    }
    if (!this.fieldConfig.idFieldChild) {
      const index = this.field.indexOf("Name");
      this.fieldConfig.idFieldChild = this.field.substr(0, index) + "Id";
    }
    if (!this.fieldConfig.nameField) {
      this.fieldConfig.nameField = this.field;
    }
    if (!this.fieldConfig.nameFieldChild) {
      this.fieldConfig.nameFieldChild = this.field;
    }
    if (this.fieldConfig.otherField) {
      this.getOtherFields();
    }
  },
  methods: {
    getData(status) {
      if (status) this.getEntityData();
    },
    //后台查询数据
    async getEntityData() {
      const {code, data} = await this.axios.post(this.$store.state.sysApi + this.queryUrl, this.queryParams);
      if (code === 200) {
        if (typeof data.aaData === "undefined") {
          this.entityData = data;
        } else this.entityData = data.aaData;
      } else this.$Message.info("获取失败，请重试!");
      //如果是查询
      if (this.isQuery) {
        let emptyItem = {};
        emptyItem[this.fieldConfig.idFieldChild] = "";
        emptyItem[this.fieldConfig.nameFieldChild] = "--Please--";
        emptyItem[this.fieldConfig.idField] = "";
        emptyItem[this.fieldConfig.nameField] = "";
        emptyItem[this.fieldConfig.otherField] = "";
        emptyItem[this.fieldConfig.showName] = "";
        this.entityData.unshift(emptyItem);
      }
    },

    /**
     * 多选快速赋值
     */
    getSelectValues(val) {
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          if (!this.pastSelectedVals.includes(val[i])) {
            this.pastSelectedVals.push(val[i]);
            if (this.group) {
              this.entityData.map((item) => {
                item.groupData.map(itemVal => {
                  if (val[i] === itemVal[this.fieldConfig.idFieldChild]) {
                    this.setEntityName(itemVal);
                  }
                })
              })
            } else {
              this.entityData.map((item) => {
                if (val[i] === item[this.fieldConfig.idFieldChild]) this.setEntityName(item);
              })
            }
          } else if (!val.includes(this.pastSelectedVals.filter(item => !val.includes(item))[0])) {
            if (this.group) {
              this.entityData.map((item) => {
                item.groupData.map(item => {
                  if (this.pastSelectedVals.filter(item => !val.includes(item))[0] === item[this.fieldConfig.idFieldChild]) {
                    this.pastSelectedVals = val;
                    this.setEntityName(item);
                  }
                })
              })
            } else {
              this.entityData.map((item) => {
                if (this.pastSelectedVals.filter(item => !val.includes(item))[0] === item[this.fieldConfig.idFieldChild]) {
                  this.pastSelectedVals = val;
                  this.setEntityName(item);
                }
              })
            }
          }
        }
      } else {
        this.$emit("on-change", {});
        this.pastSelectedVals = val;
      }
    },

    /**
     * 单选赋值
     */
    /*getSelectValue(val) {
      this.selectedValue = val;
    },*/

    /**
     * 给主表传值
     */
    setEntityName(item) {
      let submitData = {};
      //如果是单选,给每个值赋值
      if (!this.multiply) {
        submitData[this.fieldConfig.idField] = item[this.fieldConfig.idFieldChild];
        submitData[this.fieldConfig.nameField] = item[this.fieldConfig.nameFieldChild]
        Object.assign(submitData, this.setOtherFieldValue(item));
      } else {
        let sv = this.selectedValues;
        let sl = this.selectedLabels;
        //多选
        if (sv.includes(item[this.fieldConfig.idFieldChild]) && !sl.includes(item[this.fieldConfig.nameFieldChild])) {
          sl.push(item[this.fieldConfig.nameFieldChild]);
          if (this.fieldConfig.otherField) {
            this.others.push(this.setOtherFieldValue(item));
          }
        } else if (!sv.includes(item[this.fieldConfig.idFieldChild]) && sl.includes(item[this.fieldConfig.nameFieldChild])) {
          let i = 0;
          sl.filter((el, index) => {
            if (el === item[this.fieldConfig.nameFieldChild]) i = index;
          })
          sl.splice(i, 1);
          if (this.fieldConfig.otherField) {
            this.others.splice(i, 1);
          }
        }
        submitData[this.fieldConfig.idField] = this.armStringData(sv);
        submitData[this.fieldConfig.nameField] = this.armStringData(sl);
        submitData.otherName = this.others;
      }
      this.$emit("on-change", submitData);
      if (this.isCheck && this.curId === 0) {
        this.$emit("check", item);
      }
    },

    /**
     * 给每个otherFields属性赋值
     */
    setOtherFieldValue(item) {
      let data = {};
      for (let i = 0; i < this.otherFieldsChild.length; i++) {
        data[this.otherFields[i]] = item[this.otherFieldsChild[i]];
      }
      return data;
    },

    /**
     * 多选组装数据
     */
    armStringData(val) {
      let name = "";
      for (let i = 0; i < val.length; i++) {
        if (name && i !== val.length) {
          name += ",";
        }
        name += val[i];
      }
      return name;
    },

    //Option展示标签
    getTagName(item) {
      if (this.fieldConfig.showName === undefined) {
        this.fieldConfig.showName = this.fieldConfig.nameFieldChild;
      }
      let tagName = "";
      if (this.fieldConfig.showName) {
        let showName = this.fieldConfig.showName.split(",");
        for (let i = 0; i < showName.length; i++) {
          if (tagName) {
            tagName += " - ";
          }
          if (item[showName[i]] != null) tagName += item[showName[i]];
        }
      }
      return tagName;
    },

    /**
     * 拆分otherField,拆成主表和指标字段.
     */
    getOtherFields() {
      let otherFields = this.fieldConfig.otherField.split(",");
      for (let i = 0; i < otherFields.length; i++) {
        if (otherFields[i].indexOf("@") !== -1) {
          const index = otherFields[i].indexOf("@");
          this.otherFields.push(otherFields[i].substr(0, index));
          this.otherFieldsChild.push(otherFields[i].substr(index + 1));
        }
      }
    },

    setOtherFields(item) {
      for (let i = 0; i < this.otherFields.length; i++) {
        this.otherFieldData[this.otherFields[i]].push(item[this.otherFieldsChild[i]]);
      }
    }
  },
  watch: {
    parentValue: async function (val) {
      //只监控首次进来时父组件值
      if (this.watchNum === 0) {
        if (this.entityData.length === 0) await this.getEntityData();
        if (!this.multiply) {
          //单选
          for (let i = 0; i < this.entityData.length; i++) {
            if (val === this.entityData[i][this.fieldConfig.idFieldChild] ||
                parseInt(val) === this.entityData[i][this.fieldConfig.idFieldChild] ||
                val === this.entityData[i][this.fieldConfig.nameFieldChild]) {
              this.selectedValue = this.entityData[i][this.fieldConfig.idFieldChild];
              break;
            }
          }
        } else {
          let vals = val.split(",");
          if (this.group) {
            for (let j = 0; j < this.entityData.length; j++) {
              for (let k = 0; k < this.entityData[j].groupData.length; k++) {
                let data = this.entityData[j].groupData[k];
                for (let i = 0; i < vals.length; i++) {
                  if (vals[i] === this.entityData[j][this.fieldConfig.idFieldChild] ||
                      parseInt(vals[i]) === data[this.fieldConfig.idFieldChild] ||
                      vals[i] === data[this.fieldConfig.nameFieldChild]) {
                    if (!this.selectedValues.includes(data[this.fieldConfig.idFieldChild])) {
                      this.selectedValues.push(data[this.fieldConfig.idFieldChild]);
                      this.selectedLabels.push(data[this.fieldConfig.nameFieldChild])
                    }
                    if (this.fieldConfig.otherField) {
                      this.setOtherFields(data)
                    }
                  }
                }
              }
            }
          } else {
            for (let j = 0; j < this.entityData.length; j++) {
              for (let i = 0; i < vals.length; i++) {
                if (vals[i] === this.entityData[j][this.fieldConfig.idFieldChild] ||
                    parseInt(vals[i]) === this.entityData[j][this.fieldConfig.idFieldChild] ||
                    vals[i] === this.entityData[j][this.fieldConfig.nameFieldChild]) {
                  if (!this.selectedValues.includes(this.entityData[j][this.fieldConfig.idFieldChild])) {
                    this.selectedValues.push(this.entityData[j][this.fieldConfig.idFieldChild]);
                    this.selectedLabels.push(this.entityData[j][this.fieldConfig.nameFieldChild])
                  }
                  if (this.fieldConfig.otherField) {
                    this.setOtherFields(this.entityData[j])
                  }
                }
              }
            }
          }
        }
        this.watchNum++;
      }
    }
  }
};
</script>

<style scoped>

</style>
